// extracted by mini-css-extract-plugin
module.exports = {"DonutChartTrack":"GaugeChart_DonutChartTrack__1vGvK","DonutChartIndicator":"GaugeChart_DonutChartIndicator__r1TQ1","DonutChart":"GaugeChart_DonutChart__1XmDN"};